module.exports = __webpack_public_path__ + "static/media/user-image-1.6ae1a5fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/user-image-1.png
// module id = 457
// module chunks = 0